"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var TableTitle = function TableTitle(props) {
  // TODO: Daha sonra bakılacak ve pagination için footer oluşturulacak.
  // const bottomPagination = this.renderPagination('bottom');

  if (!props.title) {
    return null;
  }
  var preparedTitle = typeof props.title == 'function' ? props.title() : props.title || '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(props.prefixCls, "-title")
  }, preparedTitle);
};
var _default = exports.default = TableTitle;